import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';

const Blog = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gradient-to-b from-background to-background/95"
    >
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold mb-12">Our Story</h1>
          
          <Link 
            to="/blog/the-promptassist-story" 
            className="block group"
          >
            <div className="relative h-[400px] w-full mb-8 rounded-xl overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=2070&auto=format&fit=crop" 
                alt="The Journey of PromptAssist" 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <div className="absolute bottom-0 left-0 p-8">
                <h2 className="text-4xl font-bold mb-4 group-hover:text-purple-400 transition-colors">
                  From Frustration to Innovation: The Birth of PromptAssist
                </h2>
                <p className="text-lg text-white/90 mb-4 max-w-2xl">
                  It all started with a simple question: "Why is writing good AI prompts so hard?" 
                  Discover how a team of developers turned their daily struggles with AI tools into 
                  a solution that's helping thousands of developers work smarter, not harder.
                </p>
                <div className="flex items-center text-sm text-white/80">
                  <Clock className="h-4 w-4 mr-1" />
                  <span>8 min read</span>
                  <span className="mx-2">•</span>
                  <span>March 26, 2024</span>
                </div>
              </div>
            </div>
            <div className="mt-6 space-y-4 text-muted-foreground">
              <p>
                In this article, we share our journey of building PromptAssist, the challenges we faced, 
                and how we're making prompt engineering accessible to everyone. From late-night debugging 
                sessions to breakthrough moments, this is the story of how we're changing the way 
                developers interact with AI.
              </p>
              <p className="text-purple-400 font-medium hover:text-purple-300 transition-colors">
                Read the full story →
              </p>
            </div>
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default Blog; 